module.exports = __webpack_public_path__ + "img/8group-octopus-icon.83ee6f19.svg";